<template>
  <div>
    <!--<a-row class="justify-stretch" :gutter="24" type="flex">-->
      <!--<a-col :md="24" :lg="5">-->
        <!--<a-card class="operate-in-head sx-full-height" :bordered="false">-->
          <!--<a-input-search style="margin-bottom: 8px" placeholder="请输入社区名称" @change="onChange"/>-->
          <!--<a-tree-->
						<!--class="container-atree"-->
            <!--showLine-->
						<!--:showIcon="false"-->
            <!--@expand="onExpand"-->
						<!--:selectedKeys="selectedKeys"-->
            <!--:expandedKeys="expandedKeys"-->
            <!--:autoExpandParent="autoExpandParent"-->
            <!--@select="onSelect"-->
            <!--:treeData="treeData"-->
          <!--&gt;-->
            <!--<template slot="title" slot-scope="{title}">-->
              <!--<span v-if="title.indexOf(searchValue) > -1" :title="title">-->
                <!--{{title.substr(0, title.indexOf(searchValue))}}-->
                <!--<span style="color: #f50">{{searchValue}}</span>-->
                <!--{{title.substr(title.indexOf(searchValue) + searchValue.length)}}-->
              <!--</span>-->
              <!--<span v-else :title="title">{{title}}</span>-->
            <!--</template>-->
          <!--</a-tree>-->
        <!--</a-card>-->
      <!--</a-col>-->
        <a-card class="operate-in-head sx-full-height" :bordered="false">
          <a-form :form="form">
            <a-row :gutter="12">
              <a-col :span="6">
                <a-form-item>
                  <a-select
										:dropdownMatchSelectWidth="false"
										v-decorator="['signupId']" size="large" placeholder="请选择报名">
                    <a-select-option v-for="item of signupList" :value="item.signupNoticeId">{{item.title}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <!--管理员才有查看街道的权限-->
              <a-col :span="6" v-if="adminLevel === 'admin'">
                <a-form-item>
                  <a-select allowClear v-decorator="['street']" size="large" style="width: 100%" placeholder="请选择街道" @change="beforeChangeStreet">
                    <a-select-option v-for="item of streetList" :value="item.code">{{item.name}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

							<a-col :span="6" v-if="studentType === 1">
								<a-form-item>
									<a-select
									allowClear
									:dropdownMatchSelectWidth="false"
									:notFoundContent="'暂无数据！'"
									v-decorator="['school']" size="large"
									style="width: 100%"
									placeholder="请选择幼儿园"
									@change="onChangeSchool">
										<a-select-option v-for="item of schoolList" :value="item.id">{{item.name}}</a-select-option>
									</a-select>
								</a-form-item>
							</a-col>
              <a-col :span="4" v-if="studentType == 2">
                <a-form-item>
                  <!-- <a-select
										v-if="studentType == 1"
										v-decorator="['studentHouseType']" size="large" style="width: 100%" placeholder="请选择分类" @change="onChangeStudentHouseType">
                    <a-select-option :value="0">全部</a-select-option>
                    <a-select-option :value="1">城市居民</a-select-option>
                    <a-select-option :value="2">生态移民</a-select-option>
                  </a-select> -->
                  <a-select
									v-decorator="['grade']" size="large" style="width: 100%" placeholder="请选择年级" @change="onChangeGrade">
										<a-select-option :value="0">全部年级</a-select-option>
										<a-select-option
											v-for="(item, index) of gradeList"
											:key="index"
											:value="item">{{item}}</a-select-option>
									</a-select>
                </a-form-item>

              </a-col>
              <a-col :span="4">
                <a-form-item>
                  <a-select allowClear v-decorator="['status']" size="large" style="width: 100%" placeholder="请选择状态" @change="onChangeStatus">
                    <a-select-option :value="2">审核通过</a-select-option>
                    <a-select-option :value="1">审核待定</a-select-option>
                    <a-select-option :value="3">审核不通过</a-select-option>
                    <a-select-option :value="0">待审核</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

						<template v-if="studentType != 1">
							<a-col :span="4">
								<a-form-item>
									<a-select allowClear v-decorator="['containArea']" size="large" style="width: 100%" placeholder="原就读学校" @change="onChangeGrade">
										<a-select-option :value="0">区内</a-select-option>
										<a-select-option :value="1">区外</a-select-option>
									</a-select>
								</a-form-item>
							</a-col>

							<a-col :span="4">
								<a-form-item>
									<a-select allowClear v-decorator="['applyType']" size="large" style="width: 100%" placeholder="办理类型" @change="onChangeGrade">
										<a-select-option :value="1">材料办理</a-select-option>
										<a-select-option :value="2">积分办理</a-select-option>
									</a-select>
								</a-form-item>
							</a-col>
						</template>

              <a-col :span="5">
                <a-form-item>
                  <a-input v-decorator="['searchName']" size="large" style="width: 100%" placeholder="姓名/身份证号码/预报名号" />
                </a-form-item>
              </a-col>
            </a-row>

            <a-row :gutter="20">
              <a-col :span="4">
                <a-button size="large" style="width: 100%;" type="primary" icon="search" @click="onClickSearch">搜 索</a-button>
              </a-col>
              <a-col :span="4">
                <a-button @click="handleExportData" size="large" type="primary" icon="download" style="background: #6eb864; border-color: #6eb864; width: 100%;">导出数据</a-button>
              </a-col>
              <a-col :span="4">
                <a-button @click="handleExportLotteryData" size="large" type="primary" icon="download" style="background: #ff8943; border-color: #ff8943;">导出摇号数据</a-button>
              </a-col>
            </a-row>
          </a-form>

					<a-table
						v-show="tableData.length"
						:scroll="{x: 1280}"
						@change="handleTableChange"
						:pagination="pagination"
						:columns="filteredColumns"
						:dataSource="tableData"
						rowKey="id"
						:rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}">
						<template slot="action" slot-scope="record">
              <router-link :to='{path: "/admin/view_info", query: {studentSignupId: record.id}}' target="_blank">[查看]</router-link>
						</template>
					</a-table>
					<p v-show="tableData.length <= 0"
						class="sx-align-center"
						style="color:#aaa;">暂无数据</p>

        </a-card>
    <!--</a-row>-->
  </div>
</template>

<script>
  import AdminCommon from './mixins/admin_common';
  import config from '@/../config'
const gData = [{
  'title': '龙泉街道',
  'id': '0-0',
  'key': '龙泉街道',
  'scopedSlots': { 'title': 'title' },
  'children': [{
    'title': '龙泉幼儿园',
    'id': '0-0-0',
    'key': '龙泉幼儿园',
    'scopedSlots': { 'title': 'title' }
  }, {
    'title': '龙泉小学',
    'id': '0-0-1',
    'key': '龙泉小学',
    'scopedSlots': { 'title': 'title' }
  }, {
    'title': '龙泉中学',
    'id': '0-0-2',
    'key': '龙泉中学',
    'scopedSlots': { 'title': 'title' }
  }, {
    'title': '龙泉高级中学',
    'id': '0-0-3',
    'key': '龙泉高级中学',
    'scopedSlots': { 'title': 'title' }
  }]
}, {
  'title': '华阳街道',
  'id': '0-1',
  'key': '华阳街道',
  'scopedSlots': { 'title': 'title' },
  'children': [{
    'title': '华阳幼儿园',
    'id': '0-1-0',
    'key': '华阳幼儿园',
    'scopedSlots': { 'title': 'title' }
  }, {
    'title': '华阳小学',
    'id': '0-1-1',
    'key': '华阳小学',
    'scopedSlots': { 'title': 'title' }
  }]
}];

  const dataList = [];
  const generateList = (data, parentKey, dataList) => {
    for (let i = 0; i < data.length; i++) {
      let node = data[i];
			let { title, key } = node;

      dataList.push({
				key,
				title,
				parentKey
			});
      if (node.children) {
        generateList(node.children, key, dataList);
      }
		}
  };
	generateList(gData, '', dataList);

  const getParentKey = (key, tree) => {
    let parentKey;
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];
      if (node.children) {
        if (node.children.some(item => item.key === key)) {
          parentKey = node.key;
        } else if (getParentKey(key, node.children)) {
          parentKey = getParentKey(key, node.children);
        }
      }
    }
    return parentKey;
  };

  export default {
    mixins: [AdminCommon],
    components: {},
    data() {
      return {
        form: this.$form.createForm(this),
        signupList: [],
				expandedKeys: [],
				selectedKeys: [],

        searchValue: '',
				autoExpandParent: true,
				originTreeData: [], // 后台原始数据
				treeData: [],
				// 扁平化treeData
				treeDataList: [],
        gData,
        selectTreeKeys: null,
				selectTreeNodes: null,
				selectTreeNodesData: null,

				// 选择的参数
				orderStreetCode: '',
				orderVillageCode: '',
				orderSchoolId: '',

        tableData: [],
				selectedRowKeys: [],

				pagination: {
					current: 1,
					pageSize: 10,
					total: 0,
          showSizeChanger:true,
          showQuickJumper:true
				},

				schoolList: []

      };
		},

		computed: {
			filteredColumns() {
				let columns = [];
				// if (this.studentType !== 1) {
				// 	columns.push({
				// 		title: '分类',
				// 		align: 'center',
				// 		width: 100,
				// 		dataIndex: 'houseTypeName'
				// 	});
				// }
				columns = columns.concat([{
					title: '预约报名号',
					align: 'center',
					dataIndex: 'id'
				}, {
					title: '身份证号',
					align: 'center',
					dataIndex: 'idCard'
				}, {
					title: '姓名',
					width: 120,
					align: 'center',
					dataIndex: 'name'
				}, {
					title: '出生日期',
					width: 120,
					align: 'center',
					dataIndex: 'birthday'
				}, {
					title: '性别',
					align: 'center',
					width: 80,
					dataIndex: 'gender'
				}]);

				if (this.studentType == 1) {
					columns.push({
						title: '报名学校',
						width: 100,
						align: 'left',
						dataIndex: 'orderSchoolName'
					});
				} else {
					columns.push({
						title: '报名街道',
						width: 100,
						align: 'left',
						dataIndex: 'orderStreetName'
					}, {
						title: '报名年级',
						width: 100,
						align: 'center',
						dataIndex: 'orderGradeName'
					})
				}

				columns.push({
          title: '报名时间',
          width: 120,
          align: 'center',
          dataIndex: 'signupDate'
        })

        if(config.web.areaId ==='510112'){
          columns.push({
            title: '电话',
            align: 'center',
            dataIndex: 'mobile'
          })
        }

				columns = columns.concat([{
					title: '状态',
					align: 'center',
					width: 110,
					dataIndex: 'statusString'
				}, {
					title: '操作',
					align: 'center',
					scopedSlots: { customRender: 'action' }
				}]);

				return columns;
			}
		},

    created() {
		},

		mounted() {
			this.$nextTick(() => {
				this.fetchStreetSchoolData().then(() => {
					this.ajaxGetSearchFormData();
				})
				setTimeout(() => {
					document.querySelector('.ant-table-body').style.overflowX = 'auto';
				}, 1000);
			})
		},

    methods: {
      onExpand(expandedKeys) {
        // 展开/收起节点时触发
        this.expandedKeys = expandedKeys; // 展开指定的树节点
        this.autoExpandParent = false;
      },
      onChange(e) {
				// 搜索框内容变化时触发
        let value = e.target.value;
				let expandedKeys = [];

				if (value) {
					this.treeData = this.formatStreetListForTree(this.originTreeData, value);
					expandedKeys = this.treeDataList.map((item) => {
						if (item.title.indexOf(value) > -1) {
							return getParentKey(item.key, this.treeData);
						}
						return null;
					}).filter((item, i, self) => item && self.indexOf(item) === i);
				} else {
					this.treeData = this.formatStreetListForTree(this.originTreeData);
				}

        Object.assign(this, {
          expandedKeys,
          searchValue: value,
          autoExpandParent: true
        });
      },
      onSelect (selectedKeys, info) {
        console.log('-> 已选择的节点Keys', selectedKeys);
        console.log('-> 已选择的节点NodeTitle', info.selectedNodes[0].data.props.dataRef.title);
        console.log('-> 已选择的节点NodeId', info.selectedNodes[0].data.props.dataRef.id);
        this.selectTreeKeys = selectedKeys;
				this.selectTreeNodes = info.selectedNodes;
				this.selectTreeNodesData = info.selectedNodes.map(item => item.data.props);
				console.log('selectTreeNodesData', this.selectTreeNodesData);

				this.selectedKeys = selectedKeys;

				if (this.selectTreeNodesData) {
					let selectNode = this.selectTreeNodesData[0];
					if (selectNode.treeLevel === 1) {
						this.orderStreetCode = selectNode.id;
						this.orderVillageCode = '';
					} else if (selectNode.treeLevel === 2) {
						this.orderStreetCode = '';
						this.orderVillageCode = selectNode.id;
					}
				}

				this.getKinderSchoolData({
					streetCode: this.orderStreetCode,
					villageCode: this.orderVillageCode
				});
			},

			// 获取街道-学校树列表
			async fetchStreetSchoolData() {
				if (this.streetList && this.streetList.length) {
					this.originTreeData = this.streetList;
				} else {
					// 查询出当前用户对应区域的的街道列表和街道对应的学校列表 #李茹钰/2019-03-12#
					let { data, error } = await this.$ajax.gateway('/bm-kids/IAreaApi_getMyAreas', {
						studentType: this.studentType
					});
					this.originTreeData = data.data;
				}

				this.treeData = this.formatStreetListForTree(this.originTreeData);
				this.treeDataList = [];
				generateList(this.treeData, '', this.treeDataList);
			},

			// 将后台数据转化为 tree 所需的data
			formatStreetListForTree(data, searchValue = '') {
				function loop(d, index) {
					return {
						title: d.name,
						id: d.code,
						key: d.code,
						show: true,
						scopedSlots: { title: 'title' }
					}
				}

				let treeData = data.map((item, index) => {
					let obj = loop(item);
					obj.treeLevel = 1 // 1级 街道

					let village = item.children;
					if (village && village.length) {
						let children = village.map((village, index2) => {
							if (village.name.indexOf(searchValue) > -1) {
								let cpVillage = loop(village);
								cpVillage.treeLevel = 2;
								return cpVillage;
							}
						}).filter(v => !!v);

						obj.children = children;
					} else {
						obj.children = [];
					}

					return obj;
				}).filter(v => !!v);

				return treeData;
			},
			// 将后台数据转化为 tree 所需的data
			formatBackDataForTree(data, searchValue = '') {
				function loop(d, index) {
					return {
						title: d.name,
						id: d.code,
						key: d.code,
						show: true,
						scopedSlots: { title: 'title' }
					}
				}

				let treeData = data.map((item, index) => {
					let obj = loop(item);
					obj.treeLevel = 1 // 1级 街道

					// 中小学 只显示街道
					if (this.studentType == 2) {
						obj.children = [];
					} else {
						let streetSchools = item.streetSchools;
						if (streetSchools && streetSchools.length) {
							let children = streetSchools.map((school, index2) => {
								if (school.name.indexOf(searchValue) > -1) {
									let cpSchool = loop(school);
									cpSchool.treeLevel = 2;
									return cpSchool;
								}
							}).filter(v => !!v);

							obj.children = children;
						} else {
							obj.children = [];
						}
					}

					return obj;
				});

				return treeData;
			},

      onChangeStudentHouseType(value) {
        console.log('-> onChangeStudentHouseType', value);
			},

			onChangeGrade(value) {
        console.log('-> onChangeGrade', value);
			},

			onChangeSchool(value) {
        console.log('-> onChangeSchool', value);
			},

      onChangeStatus(value) {
        console.log('-> onChangeStatus', value);
			},

			handleTableChange(pagination) {
				console.log('pagination', pagination);
				Object.assign(this.pagination, pagination);
				this.search();
			},

      async ajaxGetSearchFormData() {
        let { data } = await this.$ajax.gateway('/bm-kids/ISignupNoticeApi_querySignupNotices', { studentType: this.studentType });

        // 处理获取的报名列表数据
        if (data.code === 200) {
          data = data.data;
          if (typeof data === 'object' && data.length > 0) {
						this.signupList = data;

						this.initParams();

						let params = this.$route.query;

						this.$nextTick(async () => {
							let { data } = await this.fetchKinderSchool(params);
							if (data) {
								this.schoolList = data;
							}

							this.$nextTick(() => {
								if (params.school) {
									this.form.setFieldsValue({ 'school': params.school });
								}

								this.onClickSearch();
							});
						});
          }
        }

        // 加载默认数据
        this.form.setFieldsValue({
          studentHouseType: 0
        });
        // this.onClickSearch();
			},

			// 初始化参数
			initParams() {
				let { status, grade, signupId, containArea, applyType, street, villageCode } = this.$route.query;

				let params = {};

				status = status !== undefined ? (+status) : undefined;
				signupId = signupId || this.signupList[0].signupNoticeId;
				applyType = applyType ? +applyType : undefined;
				containArea = containArea ? +containArea : undefined;

				if (villageCode && villageCode != 0) {
					this.selectedKeys = [villageCode];

					this.orderVillageCode = villageCode;
					this.orderStreetCode = street;

					this.expandedKeys = [street, villageCode];
				} else if (street && street != 0) {
					this.orderStreetCode = street;
					this.selectedKeys = [street];
				}

				this.form.setFieldsValue({
					status,
					grade: grade == 0 ? +grade : grade,
					signupId,
					containArea,
					applyType
				});
			},

			handleExportData() {
				let formVal = this.form.getFieldsValue();
				let params = this.getApiParams(formVal);
				// console.log('formVal------', formVal, params);
				this.exportStatisticsSignup(params);
			},
      handleExportLotteryData() {
				let formVal = this.form.getFieldsValue();
				let params = this.getApiParams(formVal);
				// console.log('formVal------', formVal, params);
				this.exportLotterySignup(params);
			},

			getApiParams({ school, signupId, street, time, reserveRange, grade, 						containArea, applyType, villageCode, status, searchName }) {
				let signupTime = ['', ''],
					reserveTime = ['', ''];

				if (time) {
					signupTime = time.map(v => v.format('YYYY-MM-DD'));
				}

				if (reserveRange) {
					reserveTime = reserveRange.map(v => v.format('YYYY-MM-DD'));
				}

				school = school || '';
        street = street || '';
				grade = grade || '';

				let ids = [];

				if (this.selectedRowKeys.length) {
					ids = this.selectedRowKeys;
				}

				return {
						reserveBegin: reserveTime[0],
						reserveEnd: reserveTime[1],
            schoolId: school,
            gradeName: grade,
            signupBegin: signupTime[0],
						signupEnd: signupTime[1],
						signupNoticeId: signupId,
						streetCode: this.orderStreetCode,
						studentType: this.studentType,
						containArea: containArea,
						applyType: applyType,
						villageCode: this.orderVillageCode,
						status,
						keyword: searchName || '',
						ids
				}
			},

			async exportStatisticsSignup({
				reserveBegin,
				reserveEnd,
				schoolId,
				signupBegin,
				signupEnd,
				signupNoticeId,
				streetCode,
				studentType,
				gradeName,
				containArea,
				applyType,
				villageCode,
				keyword,
				status,
				ids
			}) {
				// 报名统计导出 #李茹钰/2019-03-14#
					let { data } = await this.$ajax.gateway('/bm-kids/IStudentSignupApi_exportStatisticsSignupOss', {
					studentType,
					signupNoticeId,
					streetCode,
					schoolId,
					gradeName,
					signupBegin,
					signupEnd,
					reserveBegin,
					reserveEnd,
					containArea,
					applyType,
					villageCode,
					keyword,
					status,
					ids
				});

				if (data && data.code == 200 && data.data.ossFileUrl) {
					window.open(data.data.ossFileUrl, '_blank');
				}
			},
			async exportLotterySignup({
				reserveBegin,
				reserveEnd,
				schoolId,
				signupBegin,
				signupEnd,
				signupNoticeId,
				streetCode,
				studentType,
				gradeName,
				containArea,
				applyType,
				villageCode,
				keyword,
				status,
				ids
			}) {
        // 导出摇号数据 #敬瑞/2021-04-22#
					let { data } = await this.$ajax.gateway('/bm-kids/IStudentSignupApi_exportLotterySignup', {
					  body: {
              studentType,
              signupNoticeId,
              streetCode,
              schoolId,
              gradeName,
              signupBegin,
              signupEnd,
              reserveBegin,
              reserveEnd,
              containArea,
              applyType,
              villageCode,
              keyword,
              status,
              ids
            }
				});

				if (data && data.code == 200 && data.data.ossFileUrl) {
					window.open(data.data.ossFileUrl, '_blank');
				}
			},

      async onClickSearch() {
				this.pagination.current = 1;
				this.search();
			},

			search() {
				let formVal = this.form.getFieldsValue();
        console.log('-> onClickSearch formVal', formVal);
				this.fetchStudentSignupPage(formVal);
			},

			async fetchStudentSignupPage({ searchName, signupId, status, studentHouseType, grade, applyType, containArea, school, street }) {
				let houseType = studentHouseType && studentHouseType > 0 ? studentHouseType : '';
				status = status > -1 ? status : '';
				let { current, pageSize } = this.pagination;

				let orderSchoolId = this.orderSchoolId || school || '',
						// orderVillageCode = this.orderVillageCode,
						orderStreetCode = street;

				// 报名情况分页查询 #李茹钰/2019-03-13#
				let { data } = await this.$ajax.gateway('/bm-kids/IStudentSignupApi_pageStudentSignup', {
					body: {
						houseType,
						keyword: searchName,
						orderGradeName: grade || '',
						orderSchoolId,
						orderStreetCode,
						// orderVillageCode,
						pageableDto: {
							page: current,
							size: pageSize,
						},
						signupNoticeId: signupId,
						status,
						studentType: this.studentType,
						applyType,
						containArea,
            street
					}
				});
				if (data.code == 200) {
					data = data.data;

					this.pagination.total = data.totalCount;
					this.tableData = this.formatTableData(data.dataList);
				}
			},

			formatTableData(data) {
				return data.map((item, index) => {
						let obj = Object.assign({
							statusString: ['待审核', '待定', '通过', '不通过'][item.status],
							gender: ['男', '女'][item.sex]
						}, item);

						obj.houseTypeName = ['', '城市居民', '生态移民'][item.houseType];

						return obj;
					})
			},

      onSelectChange (selectedRowKeys) {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.selectedRowKeys = selectedRowKeys
      }
    }
  };
</script>

<style lang="stylus" scoped>
	.container-atree.ant-tree
		>>> li
			overflow hidden
			text-overflow: ellipsis
			white-space: nowrap
			.ant-tree-node-content-wrapper
				display inline
</style>
